// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMinimumContributionAmountDto
 */
export interface IMinimumContributionAmountDto {
    /**
     * 
     * @type {number}
     * @memberof IMinimumContributionAmountDto
     */
    minimum_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMinimumContributionAmountDto
     */
    minimum_contribution_amount_state_id?: IMinimumContributionAmountDtoMinimumContributionAmountStateIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMinimumContributionAmountDtoMinimumContributionAmountStateIdEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMinimumContributionAmountDto interface.
 */
export function instanceOfIMinimumContributionAmountDto(value: object): value is IMinimumContributionAmountDto {
    return true;
}

export function IMinimumContributionAmountDtoFromJSON(json: any): IMinimumContributionAmountDto {
    return IMinimumContributionAmountDtoFromJSONTyped(json, false);
}

export function IMinimumContributionAmountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMinimumContributionAmountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'minimum_contribution_amount': json['minimum_contribution_amount'] == null ? undefined : json['minimum_contribution_amount'],
        'minimum_contribution_amount_state_id': json['minimum_contribution_amount_state_id'] == null ? undefined : json['minimum_contribution_amount_state_id'],
    };
}

export function IMinimumContributionAmountDtoToJSON(json: any): IMinimumContributionAmountDto {
    return IMinimumContributionAmountDtoToJSONTyped(json, false);
}

export function IMinimumContributionAmountDtoToJSONTyped(value?: IMinimumContributionAmountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minimum_contribution_amount': value['minimum_contribution_amount'],
        'minimum_contribution_amount_state_id': value['minimum_contribution_amount_state_id'],
    };
}

